import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios, { API_BASE_URL } from "../../../components/api/axios";
import ImageLoader from "../../common/ImageLoader";
import "./Announcement.css";

function Announcement() {
  const [announcements, setAnnouncements] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const res = await axios.get("/announcements");
        setAnnouncements(res.data || []);
      } catch (err) {
        console.error("❌ Error fetching announcements:", err);
      }
    };

    fetchAnnouncements();
  }, []);

  return (
    <section id="announcements" className="announcements-section">
      <div className="announcements-container">
        <div className="section-header">
          <span className="section-tag">✦ LATEST HAPPENINGS</span>
          <h2 className="section-main-title">Announcements</h2>
          <p className="section-description">
            Stay up to date with the latest technical workshops, hackathons, and
            flagship events hosted by DIET ACM.
          </p>
        </div>

        {announcements.length > 0 ? (
          <div className="announcements-list">
            {announcements.map((item) => (
              <div key={item.id} className="announcement-card glass-panel glow-on-hover">
                <div className="announcement-img-wrapper">
                  <ImageLoader
                    src={`${API_BASE_URL}/${item.poster}`}
                    alt={item.title}
                    className="announcement-img"
                  />
                  <div className="img-overlay-badge">
                    <span>ACM EVENT</span>
                  </div>
                </div>

                <div className="announcement-content">
                  <h3 className="announcement-card-title">{item.title}</h3>
                  <p className="announcement-card-desc">{item.shortDescription}</p>

                  <div className="announcement-buttons">
                    <button
                      className="btn-details"
                      onClick={() =>
                        navigate(
                          `/announcement/${encodeURIComponent(
                            item.title.trim().replace(/\s+/g, "-")
                          )}`
                        )
                      }
                    >
                      <span>See Details</span>
                      <i className="fas fa-arrow-right"></i>
                    </button>
                    {item.registrationLink && (
                      <a
                        href={item.registrationLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-register-link"
                      >
                        <button className="btn-register">Register Now</button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-announcements glass-panel">
            <i className="far fa-bell no-announcements-icon"></i>
            <p>No new announcements at this moment. Stay tuned for upcoming events!</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default Announcement;
